import { apiService } from "../../../core/api";
import { API_ENDPOINTS } from "../../../core/constants/endpoints";
import { DashboardResponse } from "../types/homePageTypes";
import { BlogPost } from "../types/homePageTypes";

export class HomeService {
  async getDashboard(): Promise<DashboardResponse> {
    return apiService.get<DashboardResponse>(API_ENDPOINTS.DASHBOARD.GET_ALL);
  }

  async getUserViews(): Promise<any> {
    return apiService.get<any>(API_ENDPOINTS.USER.VIEWS);
  }

  async getLatestPosts(): Promise<BlogPost[]> {
    const response = await fetch(
      "https://eucalls.net/wp-json/eucalls/v1/latest-posts",
    );
    if (!response.ok) throw new Error("Failed to fetch blog posts");
    return response.json();
  }
}

export const homeService = new HomeService();
